import {
    Alert,
    Box,
    Chip,
    DialogContent,
    Divider,
    ListItem,
    TextField,
    Typography,
} from "@mui/material";
import debounce from "lodash/debounce";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import {
    SmsCampaignDto,
    SmsCampaignRecordDto,
    SmsCampaignService,
} from "../../../api/psc";
import {
    DialogHeader,
    EmptyListMessage,
    EndOfInfiniteListMessage,
    Spinner,
} from "../../../components/exports";
import { ParseSmsCampaignRecordStatus } from "../constants/SmsCampaignContants";

// updated
export default function SmsCampaignRecordDialog(props: {
    smsCampaign: SmsCampaignDto;
}) {
    const [records, setRecords] = useState<SmsCampaignRecordDto[]>([]);
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [recordsCount, setRecordsCount] = useState<number>(0);
    const [isFetching, setIsFetching] = useState<boolean>(true);

    const fetchRecords = (term?: string) => {
        SmsCampaignService.getSmsCampaignRecords(
            props.smsCampaign.id,
            "1",
            records.length,
            term
        ).then((result) => {
            setRecords(records.concat(result.results));
            setRecordsCount(result.count);
            setIsFetching(false);
        });
    };

    const debounceFn = useCallback(
        debounce((i) => {
            setIsFetching(true);
            setRecords([]);
            fetchRecords(i);
        }, 500),
        []
    );

    const handleSearchTermChange = (
        ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        setSearchTerm(ev.target.value);
        debounceFn(ev.target.value);
    };

    useEffect(() => {
        fetchRecords();
    }, []);

    return (
        <DialogContent id="scrollableDiv" sx={{ p: 0 }}>
            <DialogHeader title="رکورد های کمپین" />

            <Box sx={{ p: 2 }}>
                <TextField
                    value={searchTerm}
                    onChange={handleSearchTermChange}
                    sx={{ mb: 2 }}
                    fullWidth
                    label={"جستجو در شماره تلفن ها"}
                />

                <Alert severity="info" sx={{ mb: 2 }}>
                    توجه داشته باشید ۳ رقم از شماره موبایل ها به دلایل امنیتی
                    نمایش داده نمیشود
                </Alert>

                {isFetching && <Spinner />}

                {!isFetching && (
                    <>
                        <EmptyListMessage
                            condition={records.length === 0}
                            message="رکوردی یافت نشد، توجه داشته باشید که رکورد های پیامکی تنها تا ۹۰ روز قابل مشاهده خواهند بود."
                        />

                        <InfiniteScroll
                            scrollableTarget="scrollableDiv"
                            dataLength={records.length}
                            next={fetchRecords}
                            endMessage={<EndOfInfiniteListMessage />}
                            hasMore={records.length < recordsCount}
                            loader={<Spinner />}
                        >
                            {records.map((record, i) => {
                                const statusInfo = ParseSmsCampaignRecordStatus(
                                    record.deliveryStatus
                                );
                                return (
                                    <Box key={record.id}>
                                        <ListItem>
                                            <Typography sx={{ flexGrow: 1 }}>
                                                {record.phoneNumber}
                                            </Typography>
                                            <Chip
                                                sx={{
                                                    bgcolor: statusInfo.color,
                                                    color: "white",
                                                }}
                                                label={statusInfo.text}
                                            />
                                        </ListItem>
                                        {i !== records.length - 1 && (
                                            <Divider />
                                        )}
                                    </Box>
                                );
                            })}
                        </InfiniteScroll>
                    </>
                )}
            </Box>
        </DialogContent>
    );
}
